const simpleXssValidator = {
  validateColor: (color: string) => {
    let validate = false;

    if (color) {
      const matchers = [
        {
          label: 'rgb',
          matcher: /rgb\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)/gim,
        },
        {
          label: 'rgba',
          matcher:
            /rgba\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3}), ?([01]?.?\d{1,3})\)/gim,
        },
        {
          label: 'hex',
          matcher: /#[0-9A-F]{3,6}/gim,
        },
        {
          label: 'hsl',
          matcher: /hsl\((\d{1,3}), ?(\d{1,3}%), ?(\d{1,3}%)\)/gim,
        },
        {
          label: 'hsla',
          matcher:
            /hsla\((\d{1,3}), ?(\d{1,3}%), ?(\d{1,3}%), ?([01]?.?\d{1,3})\)/gim,
        },
        {
          label: 'plaintext color',
          matcher: /^[a-zA-Z]+$/g,
        },
      ];

      matchers.forEach(item => {
        if (!validate && item.matcher.test(color)) {
          validate = true;
        }
      });
    }

    return validate;
  },
};

export { simpleXssValidator };
